import { styled as muiStyled } from "@mui/material/styles";
import MuiTextField from "@mui/material/TextField";
import { DarkGrey, White01 } from "src/styles/color";
import font from "src/styles/font";

const TextField = muiStyled(MuiTextField, {
  shouldForwardProp: (prop) => prop !== "sx",
})((props) => ({
  ".MuiOutlinedInput-root": {
    borderRadius: 16,
  },
  "& .MuiInputBase-input": {
    padding: "12px 16px",
  },
  /* multiline */
  "& .MuiOutlinedInput-root.MuiInputBase-multiline": {
    padding: 0,
  },
  /* focus */
  "& .MuiInputLabel-root[data-shrink=false]:not(.Mui-focused)": {
    transform: "translate(16px, 12px) scale(1)",
  },
  ".MuiInputBase-root.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline":
    {
      borderColor: DarkGrey,
    },
  ".MuiInputLabel-root.Mui-focused, .MuiInputLabel-root[data-shrink=true]": {
    transform: "translate(16px, -9px) scale(0.75)",
    color: DarkGrey,
  },
  /* disabled */
  ".MuiInputBase-root.Mui-disabled": {
    backgroundColor: White01,
  },
  ...(props.size === "small" && {
    "& .MuiInputBase-input": {
      padding: "10px 16px",
    },
    "& .MuiInputLabel-root[data-shrink=false]:not(.Mui-focused)": {
      transform: "translate(14px, 10px) scale(1)",
    },
  }),
  [props.theme.breakpoints.down("md")]: {
    "& .MuiInputBase-input": {
      // padding: "8px 12px",
      fontSize: "0.875rem",
      minHeight: 24,
    },
  },
  [props.theme.breakpoints.down("sm")]: {
    "& .MuiInputBase-input": {
      padding: "8px 12px",
      fontSize: font.size.sm,
      minHeight: 24,
    },
    "& .MuiInputLabel-root[data-shrink=false]:not(.Mui-focused)": {
      fontSize: font.size.sm,
      transform: "translate(12px, 10px) scale(1)",
    },
    "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root[data-shrink=true]":
      {
        transform: "translate(12px, -9px) scale(0.75)",
        color: DarkGrey,
      },
  },
}));

export default TextField;
